import { Components, Formio } from 'formiojs';
import FieldComponent from 'formiojs/components/_classes/field/Field';


export class TagInputComponent extends FieldComponent {
  private tags: string[] = [];
    updateValue: any;
    element: any;

  static schema() {
    return FieldComponent.schema({
      type: 'taginput',
      label: 'Tags',
      key: 'tags',
      input: true,
    });
  }

  static get builderInfo() {
    return {
      title: 'Tag Input',
      icon: 'tags',
      group: 'basic',
      weight: 50,
      schema: TagInputComponent.schema(),
    };
  }

  render() {
    return super.render(`
      <div class="tag-input-container">
        <ul class="tags"></ul>
        <input type="text" class="tag-input-field" placeholder="Add a tag..." />
      </div>
    `);
  }

  attach(element: any) {
    const input = element.querySelector('.tag-input-field');
    const tagList = element.querySelector('.tags');

    const renderTags = () => {
      tagList.innerHTML = this.tags
        .map(
          (tag, i) => `
          <li class="tag">
            <span>${tag}</span>
            <i class="remove" data-index="${i}">&times;</i>
          </li>`
        )
        .join('');
    };

    const addTag = (value: string) => {
      value = value.trim();
      if (value && !this.tags.includes(value)) {
        this.tags.push(value);
        this.updateValue(this.tags.join(','), { modified: true });
        renderTags();
      }
      input.value = '';
    };

    const removeTag = (index: number) => {
      this.tags.splice(index, 1);
      this.updateValue(this.tags.join(','), { modified: true });
      renderTags();
    };

    input.addEventListener('keyup', (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ',') {
        addTag((e.target as HTMLInputElement).value);
      }
    });

    tagList.addEventListener('click', (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.classList.contains('remove')) {
        const index = parseInt(target.dataset['index'] || '0', 10);
        removeTag(index);
      }
    });

    return super.attach(element);
  }

  getValue() {
    return this.tags.join(',');
  }

  setValue(value: any) {
    if (Array.isArray(value)) {
      this.tags = value;
    } else if (typeof value === 'string') {
      this.tags = value.split(',').map((v) => v.trim());
    }
    const list = this.element.querySelector('.tags');
    if (list) {
      list.innerHTML = this.tags
        .map(
          (tag, i) => `
          <li class="tag">
            <span>${tag}</span>
            <i class="remove" data-index="${i}">&times;</i>
          </li>`
        )
        .join('');
    }
  }
}
